import React from 'react';
import cls from 'classname';

const DatabaseCurrency = (props) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={'none'}
    stroke={'#707BA0'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={cls(props.className, 'icon icon-database-filter')}
  >
    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
  </svg>
)};
export default DatabaseCurrency;
